import React from 'react' 
import BasicState from "@libs/basic-view"    
import InheritanceForm from '../../pe-topos-module/views/admin/InheritanceForm' 

class InheritanceAdminView extends BasicState {
    props: any
    addRender = () => {  
        return <div className="container mb-5"> 
            <InheritanceForm { ...this.props } /> 
        </div> 
    }
} 

export default InheritanceAdminView